<a routerLink="/dashboard" [queryParams]="{subscription_id: subscriptionService.subscriptionId()}">
    < {{ 'BackToContractInventory' | translate }}</a>

        @if (this.workflowService.workflowId()) {
        <div class="header">
            <span><b>{{this.workflowService.workflowName()}}</b></span>
            <mat-icon color="primary" (click)="editName()">edit</mat-icon>
        </div>

        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <b>{{'DocUpload' | translate }}</b>

            </mat-expansion-panel-header>

            <div class="upload-wrapper">

                <h3>{{'SelectAnalysisType' | translate }}*</h3>

                <mat-form-field>
                    <mat-select [formControl]="analysisTypeFormControl" [placeholder]="'SelectAnalysisType' | translate" [disabled]="promptSetsLoading()">
                        @if (promptSetsLoading()) {
                            <mat-option disabled>
                                <mat-spinner [diameter]="16" style="display:inline-block;vertical-align:middle;margin-right:8px"></mat-spinner>
                                <span>{{ 'Loading' | translate }}...</span>
                            </mat-option>
                        } @else {
                            @for (promptSet of contractChecks; track promptSet.prompt_set_id) {
                                <mat-option [value]="promptSet.prompt_set_id">{{promptSet.name}}</mat-option>
                            }
                        }
                    </mat-select>
                </mat-form-field>

                <shared-upload [workflowId]="workflowService.workflowId()!" workflowType="documents" [fileList]="workflowService.fileList()" [fileLimit]="15" [fileFormats]="data.fileFormats" (fileProcessEvent)="updateFileData($event)" (deleteFileEvent)="deleteFileData($event)"></shared-upload>

                <div class="actions">
                    <!-- Resume / Full mode toggle — only shown when there are no completed results yet,
                         or while analysis is actively running (to show the chosen mode) -->
                    @if (workflowService.contractResults().length === 0 && !isAnalyzing()) {
                    <div class="mode-toggle-wrapper">
                        <span class="mode-toggle-label">{{'AnalysisMode' | translate }}:</span>
                        <div class="mode-toggle">
                            <button class="mode-btn" [class.active]="analysisMode() === 'resume'" (click)="setAnalysisMode('resume')" [disabled]="isAnalyzing()">
                                {{'ModeResume' | translate }}
                            </button>
                            <button class="mode-btn" [class.active]="analysisMode() === 'full'" (click)="setAnalysisMode('full')" [disabled]="isAnalyzing()">
                                {{'ModeFull' | translate }}
                            </button>
                        </div>
                        <span class="mode-hint">
                            @if (analysisMode() === 'resume') {
                                {{'ModeResumeHint' | translate }}
                            } @else {
                                {{'ModeFullHint' | translate }}
                            }
                        </span>
                    </div>
                    }

                    <div class="analyze-btn-wrapper">
                        <button mat-button mat-flat-button color="primary" (click)="analyseContract()" [disabled]="!hasProcessedFiles() || isAnalyzing() || !analysisTypeFormControl.value">
                            {{'AnalyseContract' | translate }}
                        </button>
                        @if ((!hasProcessedFiles() || !analysisTypeFormControl.value) && !isAnalyzing()) {
                            <span class="disabled-hint">{{ analyzeButtonTooltip }}</span>
                        }
                    </div>
                    
                    <!-- Processing Badge — only shown when no progress bar is available yet -->
                    @if (((processService.status() === 'running') || ((loaderService.loader$ | async)?.length ?? 0) > 0) && !analysisProgress()) {
                    <div class="processing-badge">
                        <mat-icon>sync</mat-icon>
                        <span>{{ 'Processing' | translate }}...</span>
                        <mat-spinner [diameter]="20"></mat-spinner>
                    </div>
                    }
                </div>

                <!-- Re-run confirmation banner — shown when user clicks Analyze while analysis is in progress -->
                @if (showRerunConfirm()) {
                <div class="rerun-confirm-banner">
                    <mat-icon class="rerun-warn-icon">warning_amber</mat-icon>
                    <div class="rerun-confirm-body">
                        <span class="rerun-confirm-title">{{'RerunConfirmTitle' | translate }}</span>
                        <span class="rerun-confirm-desc">
                            {{ analysisProgress()?.completedPrompts }} / {{ analysisProgress()?.totalPrompts }} {{'RerunConfirmDesc' | translate }}
                        </span>
                        <div class="rerun-confirm-actions">
                            <button mat-stroked-button (click)="confirmRerun('resume')">
                                <mat-icon>play_arrow</mat-icon>
                                {{'ModeResume' | translate }} — {{'ModeResumeHint' | translate }}
                            </button>
                            <button mat-stroked-button color="warn" (click)="confirmRerun('full')">
                                <mat-icon>replay</mat-icon>
                                {{'ModeFull' | translate }} — {{'ModeFullHint' | translate }}
                            </button>
                            <button mat-button (click)="cancelRerun()">
                                {{'Cancel' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
                }

                <!-- Analysis progress bar — inside the upload box, beneath the Analyze button -->
                @if (analysisProgress(); as progress) {
                <div class="analysis-progress-section">
                    <div class="progress-header">
                        <span class="progress-title">{{'AnalysisProgress' | translate }}</span>
                        <span class="progress-status" [class]="'status-' + progress.status">
                            {{ progress.status.replace('_', ' ') }}
                        </span>
                        <span class="progress-count">{{ progress.completedPrompts }} / {{ progress.totalPrompts }} {{'PromptsAnalyzed' | translate }}</span>
                        <span class="progress-percent">{{ analysisProgressPercent() }}%</span>
                    </div>
                    <mat-progress-bar
                        [mode]="progress.status === 'in_progress' || progress.status === 'not_started' ? 'buffer' : 'determinate'"
                        [value]="analysisProgressPercent()"
                        [bufferValue]="analysisProgressPercent()"
                        [color]="progress.status === 'failed' ? 'warn' : 'accent'">
                    </mat-progress-bar>
                    @if (progress.completedAt) {
                    <span class="progress-completed-at">
                        {{'LastAnalyzed' | translate }}: {{ progress.completedAt | date:'dd MMM yyyy, HH:mm' }}
                    </span>
                    }
                    @if (progress.failedPromptIdentifiers.length > 0) {
                    <div class="progress-failed-hint">
                        <mat-icon class="failed-icon">warning</mat-icon>
                        <span>{{ progress.failedPromptIdentifiers.length }} {{'PromptsFailed' | translate }}</span>
                    </div>
                    }
                </div>
                }
            </div>
        </mat-expansion-panel>

        @if (this.workflowService.contractResults().length > 0 && hasProcessedFiles()) {

        <div class="actions">
            <div>
                <h3><b>{{'AnalysisResults' | translate }} <span class="result-count">({{ workflowService.contractResults().length }}{{ analysisProgress() && analysisProgress()!.status === 'in_progress' && analysisProgress()!.totalPrompts > 0 ? '/' + analysisProgress()!.totalPrompts : '' }})</span></b></h3>
                <div>
                    <span>{{'ApplyFilter' | translate }} : </span>
                    <chip [status]="ContractStatus.YES" [selected]="this.workflowService.filters().yes" (click)="filterResults('yes')">{{'Yes' | translate }} ({{ this.workflowService.shortAnswerCounts().yes }})</chip>
                    <chip [status]="ContractStatus.NO" [selected]="this.workflowService.filters().no" (click)="filterResults('no')">{{'No' | translate }} ({{ this.workflowService.shortAnswerCounts().no }})</chip>
                    <chip [status]="ContractStatus.CHECK" [selected]="this.workflowService.filters().check" (click)="filterResults('check')">{{'ToBeChecked' | translate }} ({{ this.workflowService.shortAnswerCounts().zuprufen }})</chip>
                </div>

            </div>
            <button mat-button mat-flat-button color="primary" (click)="downloadResults()">
                <mat-icon>open_in_new</mat-icon>
                {{'ExcelExport' | translate }}
            </button>
        </div>

        <div class="list">
            <div class="example-action-buttons">
                <button mat-button class="expandCollapse" (click)="toggleAccordion()">
                    <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                    {{ isExpanded ? ('CollapseAll' | translate ) : ('ExpandAll' | translate ) }}
                </button>
            </div>
            <mat-accordion class="example-headers-align" multi>
                @for (contract of (this.workflowService.contractFilteredResults()); track contract; let i = $index) { @if (contract.files.length > 0) {
                <analysis-result-item [contract]="contract" [contractIndex]="i" [outputSchema]="selectedPromptSetSchema" /> } }
            </mat-accordion>
        </div>
        } @else if (isAnalyzing()) {
        <div class="message analysing">
            <mat-icon>hourglass_top</mat-icon>
            <span>{{'Processing' | translate }}</span>
        </div>
        } @else if (!this.workflowService.specifications() && !errorDismissed()){
        <div class="error-banner enhanced">
            <mat-icon class="error-icon">error</mat-icon>
            <div class="error-content">
                <h3 class="error-title">{{'AnalysisErrorTitle' | translate }}</h3>
                <p class="error-description">{{'AnalysisErrorEnhanced' | translate }}</p>
                
                <!-- Action buttons -->
                <div class="error-actions">
                    <button mat-flat-button color="warn" (click)="reloadPage()">
                        <mat-icon>refresh</mat-icon>
                        {{'ReloadPage' | translate }}
                    </button>
                    <button mat-stroked-button (click)="clearAndRestart()">
                        <mat-icon>delete_sweep</mat-icon>
                        {{'ClearAndRestart' | translate }}
                    </button>
                    <button mat-button (click)="contactSupport()">
                        <mat-icon>support_agent</mat-icon>
                        {{'ContactSupport' | translate }}
                    </button>
                </div>
                
                <!-- Expandable technical details -->
                <details class="error-details">
                    <summary>{{'TechnicalDetails' | translate }}</summary>
                    <pre>{{ getErrorDetails() }}</pre>
                </details>
            </div>
            
            <!-- Close button -->
            <button mat-icon-button class="error-close" (click)="dismissError()" [attr.aria-label]="'Close' | translate">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        }} @if (this.workflowService.status() === "error" && !contractErrorDismissed()) {
        <div class="error-banner enhanced">
            <mat-icon class="error-icon">error</mat-icon>
            <div class="error-content">
                <h3 class="error-title">{{'ContractAnalysisErrorTitle' | translate }}</h3>
                <p class="error-description">{{'ContractAnalysisErrorEnhanced' | translate }}</p>
                
                <!-- Specific recovery steps -->
                <div class="error-recovery-steps">
                    <h4>{{'WhatYouCanDo' | translate }}:</h4>
                    <ol>
                        <li>{{'CheckFileFormats' | translate }}</li>
                        <li>{{'ReduceFileCount' | translate }}</li>
                        <li>{{'TryDifferentAnalysisType' | translate }}</li>
                        <li>{{'WaitAndRetry' | translate }}</li>
                    </ol>
                </div>
                
                <!-- Action buttons -->
                <div class="error-actions">
                    <button mat-flat-button color="warn" (click)="retryAnalysis()">
                        <mat-icon>replay</mat-icon>
                        {{'RetryAnalysis' | translate }}
                    </button>
                    <button mat-stroked-button (click)="deleteAllFiles()">
                        <mat-icon>delete</mat-icon>
                        {{'DeleteAllFiles' | translate }}
                    </button>
                    <button mat-button (click)="showHelp()">
                        <mat-icon>help</mat-icon>
                        {{'GetHelp' | translate }}
                    </button>
                </div>
            </div>
            
            <!-- Close button -->
            <button mat-icon-button class="error-close" (click)="dismissContractError()" [attr.aria-label]="'Close' | translate">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        }